import React from "react";
import { images } from "../../data/content";
import { TransformCta } from "../ui/TransformCta";
export function CreatorSection() {
  return <section className="bg-paper px-5 py-16 sm:py-24" data-id="element-59" data-mp="2bd3y47mxb7wn">
      <div className="mx-auto max-w-5xl md:grid md:grid-cols-[2fr_3fr] md:items-start md:gap-12" data-id="element-60" data-mp="2pdeozao8gmht">
        <div className="mx-auto max-w-sm md:sticky md:top-8" data-id="element-61" data-mp="2kdsayz0kz27y">
          <img src={images.creator} alt="Dr. Nathan Brooks in his dental clinic" className="aspect-[4/5] w-full rounded-3xl object-cover object-top" data-id="element-62" data-mp="2kc8vhamr0v78" />
        </div>
        <div className="mt-8 md:mt-0" data-id="element-63" data-mp="26eaia8k5z4tb">
          <p className="text-sm font-bold uppercase tracking-[0.18em] text-cyan" data-id="element-64" data-mp="26fc334qzf5o8">About the Creator</p>
          <h2 className="mt-2 font-display text-[2.2rem] font-extrabold leading-tight text-ink sm:text-5xl" data-id="element-65" data-mp="21msg5h6emy6r">
            Dr. Nathan Brooks
          </h2>
          <p className="mt-1 text-[16px] font-semibold text-navy" data-id="element-66" data-mp="18ywl0gwhhec3">Endodontic Educator & Creator of the Endo Blueprint™</p>
          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-ink/85" data-id="element-67" data-mp="2t4r7tw0duc46">
            <p data-id="element-68" data-mp="2y32keei2b0q3">For years, I've seen how much information dental professionals are expected to understand.</p>
            <p data-id="element-69" data-mp="32tiz01xmcse1">
              We study diagnosis. We study anatomy. We learn about instrumentation, irrigation, obturation, and treatment
              outcomes.
            </p>
            <p data-id="element-70" data-mp="2a5dd3butwxcm">
              Each subject matters. But studying them separately doesn't always make it easy to see how they connect when
              we're reviewing a case or preparing a clinical discussion. That observation inspired me to create the Endo
              Blueprint™.
            </p>
            <p data-id="element-71" data-mp="2o54z9zvi1k1p">
              I didn't want to create another extensive textbook or a course filled with hours of lectures.{" "}
              <strong className="text-ink" data-id="element-72" data-mp="3um042liiu3w0">
                I wanted to build a practical visual reference that brings related concepts together in one organized
                framework.
              </strong>{" "}
              Something you can open, navigate, study, and revisit.
            </p>
            <p data-id="element-73" data-mp="1vh8gegccoz2x">
              My intention is not to replace your clinical education, experience, or judgment. It's to give you another way
              to organize the information you already have.
            </p>
            <p data-id="element-74" data-mp="24igfh0moy3y2">I hope the Endo Blueprint™ becomes a useful part of your professional learning and case-review process.</p>
            <p className="font-display text-2xl font-bold italic text-navy" data-id="element-75" data-mp="1gru5v4x1gbly">— Dr. Nathan Brooks</p>
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-3xl" data-id="element-76" data-mp="1qh40osj9o8dr">
        <TransformCta label="Start Organizing My Case Reviews" data-id="element-77" data-mp="1qi5kblecm373" />
      </div>
    </section>;
}